import { ulid } from 'ulid';

/**
 * Per-request correlation identifier. Generated on the client and sent as
 * `X-Correlation-Id` so the same value appears in PWA telemetry, the API
 * server logs (Serilog enricher in the IT-API-Claude side), SQL Server
 * Application Name, the QBWC sync log, etc.
 */
export const CORRELATION_HEADER = 'X-Correlation-Id';

export function newCorrelationId(): string {
  return ulid();
}
